import { InputBase } from './input-base'

export class InputDropdown extends InputBase<string> {
  controlType = 'dropdown'
}
